import { render, staticRenderFns } from "./QuotationsStats.vue?vue&type=template&id=c1be824e"
import script from "./QuotationsStats.vue?vue&type=script&lang=ts"
export * from "./QuotationsStats.vue?vue&type=script&lang=ts"
import style0 from "./QuotationsStats.vue?vue&type=style&index=0&id=c1be824e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports